export type IssueTab = { key: string; label: string; count: number };

interface IssuesTabsProps {
  tabs: IssueTab[];
  activeTab: string;
  onChange: (key: string) => void;
  className?: string;
}

export const withCount = ({ label, count }: IssueTab) => (count > 0 ? `${label} (${count})` : label);

export const IssuesTabs = ({ tabs, activeTab, onChange, className = '' }: IssuesTabsProps) => (
  <div className={`hidden sm:flex flex-wrap items-center gap-x-2 ${className}`}>
    {tabs.map((tab) => (
      <button
        key={tab.key}
        className={`${activeTab === tab.key ? 'border-black text-black font-bold' : 'border-transparent text-gray-600 hover:text-gray-900'} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm transition-colors`}
        onClick={() => onChange(tab.key)}
      >
        {withCount(tab)}
      </button>
    ))}
  </div>
);
